import { apiBaseQuery } from '../../api/services/rtkQuery/apiBaseQuery';
import { postBattlesLocateMutation, postBattlesGameStartMutation, postBattlesRewardClaimMutation } from './queries';
export var battlesApi = apiBaseQuery.injectEndpoints({
  endpoints: function endpoints(builder) {
    return {
      postBattlesLocate: builder.mutation(postBattlesLocateMutation),
      postBattlesGameStart: builder.mutation(postBattlesGameStartMutation),
      postBattlesRewardClaim: builder.mutation(postBattlesRewardClaimMutation)
    };
  }
});
battlesApi.enhanceEndpoints({
  addTagTypes: ['Battles'],
  keepUnusedDataFor: 10
});
var usePostBattlesLocateMutation = battlesApi.usePostBattlesLocateMutation,
  usePostBattlesGameStartMutation = battlesApi.usePostBattlesGameStartMutation,
  usePostBattlesRewardClaimMutation = battlesApi.usePostBattlesRewardClaimMutation,
  _battlesApi$endpoints = battlesApi.endpoints,
  postBattlesLocate = _battlesApi$endpoints.postBattlesLocate,
  postBattlesGameStart = _battlesApi$endpoints.postBattlesGameStart,
  postBattlesRewardClaim = _battlesApi$endpoints.postBattlesRewardClaim;
export { usePostBattlesLocateMutation, usePostBattlesGameStartMutation, usePostBattlesRewardClaimMutation, postBattlesLocate, postBattlesGameStart, postBattlesRewardClaim };